export enum CouponType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

export interface Coupon {
  _id?: string;
  code: string;
  type: CouponType;
  value: number;
  currency?: string;
  expiresAt?: Date;
  isActive: boolean;
  usageCount: number;
  maxUsage?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CreateCouponDto {
  code: string;
  type: CouponType;
  value: number;
  currency?: string;
  expiresAt?: Date;
  isActive?: boolean;
  maxUsage?: number;
}
